export default {

    paginas:[
        {
            tipotela:'telacheia',
            htmlContentEsquerda:{
                titulo:`Ficha Digital e Web Check in`,
                subtitulo:`(CONFIGURAÇÃO)`
            },
            htmlContentDireita:{
                conteudo:``
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-1-aniversario-galeria-assinatura.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Aniversariante e Galeria de Assinatura</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-2-termos.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Termos</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-3-webcheckin-geral.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Web Check in Geral</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-4-boas-vindas.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Tela de Boas Vindas</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-5-documentos.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Documentos do web check in</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-6-contatos.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Contatos do web check in</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-7-envios-links.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Envios dos links</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/Configuracoes/config-8-generos.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Generos</h1>
            `
            }
        },
        {
            tipotela:'telacheia',
            htmlContentEsquerda:{
                titulo:`Obrigado!!`,
                subtitulo:``
            },
            htmlContentDireita:{
                conteudo:``
            }
        },
    ]

}